import { Flex, Loader } from '@mantine/core';
import { FormsListContextProvider } from './context';
import { FormsListView } from './FormsListView';
import { useGetCurrentBoard } from '../../../api/boards';
import { NoAccess } from '../../../components/shared';

export const FormsList = () => {
  const { board, isCurrentBoardLoading } = useGetCurrentBoard();
  const hasBoardTemplateFeature = board?.canAccessTemplateCreator || false;

  if (isCurrentBoardLoading) {
    return (
      <Flex justify="center" align="center" h="100%">
        <Loader />
      </Flex>
    );
  }

  if (!hasBoardTemplateFeature) {
    return <NoAccess />;
  }

  return (
    <FormsListContextProvider>
      <FormsListView />
    </FormsListContextProvider>
  );
};
